module.exports = __webpack_public_path__ + "static/media/Helen.7f182855.png";